import { lazy, useCallback, useContext, useState } from 'react';
import useParams from 'hooks/useParams';
import { useTestExercise } from 'hooks/useTestExercise';
import { LanguageContext } from 'providers/LanguageProvider';
import { UserContext } from 'providers/UserProvider';
import b64toBlob from 'utils/b64toBlob';
import { eersteTestvluchtTesten } from 'mocks/exercises/coachCodi/1848_232904';
import { UserInfo } from './UserInfo';

const Scratch = lazy(() => import('../partials/Scratch'));

export default function Exercise({ exercise, isRestarting, restart }) {
  const { studioId } = useParams();
  const user = useContext(UserContext);
  const [isSaving, setIsSaving] = useState(false);

  const {
    isLoading: isLoadingTests,
    results: testResults,
    test,
  } = useTestExercise({
    exerciseId: exercise.exerciseId,
    language: exercise?.exerciseLanguage,
    testPlanId: exercise.versionTestPlanId,
    versionId: exercise.versionId,
  });

  const { language } = useContext(LanguageContext);

  const saveExercise = () =>
    new Promise((resolve) => {
      setIsSaving(true);
      setTimeout(() => {
        setIsSaving(false);
        resolve('foo');
      }, 500);
    });

  const save = useCallback(
    ({ exerciseBlob }) => {
      if (!!exerciseBlob) {
        return saveExercise({
          exerciseFile: exerciseBlob,
          exerciseId: exercise?.exerciseId,
          exerciseVersionId: exercise?.versionId,
          language: exercise?.exerciseLanguage,
          studioId,
          testPlanId: exercise?.versionTestPlanId,
        });
      }

      return null;
    },
    [
      exercise?.exerciseId,
      exercise?.exerciseLanguage,
      exercise?.versionId,
      exercise?.versionTestPlanId,
      studioId,
    ],
  );

  const saveCurrentExercise = () => {
    if (exercise?.content) {
      saveExercise({
        exerciseFile: b64toBlob(exercise?.content),
        exerciseId: exercise?.exerciseId,
        exerciseVersionId: exercise?.versionId,
        language: exercise?.exerciseLanguage,
        studioId,
        testPlanId: exercise?.versionTestPlanId,
      });
    }
  };

  return (
    <Scratch
      exercise={{
        blob: b64toBlob(exercise?.content),
        coachCodiMock: eersteTestvluchtTesten,
        exerciseVersionId: exercise?.versionId,
        id: exercise?.exerciseId,
        language,
        testPlanId: exercise?.versionTestPlanId,
        testResults,
        title: exercise?.exerciseTitle,
        versionName: exercise?.versionName,
      }}
      isLoading={false}
      isLoadingTests={isLoadingTests}
      isOwnedExercise
      isRestarting={isRestarting}
      isSaving={isSaving}
      language={language}
      onExerciseLoaded={() => {
        saveCurrentExercise();
      }}
      restart={restart}
      save={save}
      test={test}
      userInfo={<UserInfo user={user} />}
    />
  );
}
